import type { ScreenerState } from "epsm-api-types/models";

export const DEFAULT_ROWS_LIMIT = 500;

export const DEFAULT_STATE: ScreenerState = {
	userId: "",
	itemName: "",
	fields: [
		"ticker",
		"name",
		"rt_price",
		"rt_price_chg.d1",
		"rt_price_chg.d5",
		"em_score",
		"roe.0_Y",
		"days_to_cover_quantity",
		"pe_ttm_ratio",
		"pe_ftm_ratio",
		"powerday_trend_status",
	],
	sort: [
		{
			name: "ticker",
			order: 1,
		},
	],
	filter: [
		{ name: "primary_listing", condition: "eq", value: true },
		{
			name: "listing_exchange_mic",
			condition: "in",
			value: ["ARCX", "BATS", "XNAS", "XNYS"],
		},
		{
			name: "code",
			condition: "in",
			value: ["DR", "EQS", "MF"],
		},
		{
			name: "adj_volume_xd.1_D",
			condition: "gte",
			value: 100,
		},
		{ name: "market_cap", condition: "gte", value: 5000000 },
		{ name: "market_cap", condition: "lte", value: 3410571403333 },
	],
};

export const scorerPrefix = "scoring_";

export const DEFAULT_SCORER_COLUMNS = [
	{
		name: `${scorerPrefix}em_score`,
		title: "EM Score Earnings Momentum",
		titleShort: "EM Earn. Mom.",
		titleAbbreviation: "EM",
		description:
			"Earning Momentum score EM: A numerical value from -50 to +50 (+50 being best) which evaluates both the earnings and the sales momentum action of a stock. A positive number is a stock with one of these variable in momentum. A score greater than 20 are stock with both momentum active. ",
		groupName: "EPS/Sales Growth",
		type: "num",
	},
	{
		name: `${scorerPrefix}pe_ttm_ratio`,
		title: "PE ratio Trailing Twelve Months BNRI (Price Earnings)",
		titleShort: "PE TTM",
		titleAbbreviation: "PE TTM",
		description:
			"Price Earnings Ratio (PE Ratio) Trailing Twelve months (last 4 quarters)  BNRI methodology from Zacks financials.",
		groupName: "Ratios & Multiples",
		type: "num",
	},
	{
		name: `${scorerPrefix}roe`,
		title: "Return on Equity",
		titleShort: "ROE",
		titleAbbreviation: "ROE",
		description:
			"Return on equity (ROE) is the amount of net income returned as a percentage of shareholders equity. Return on equity measures a corporation's profitability by revealing how much profit a company generates with the money shareholders have invested. The ROE is useful for comparing the profitability of a company to that of other firms in the same industry.",
		groupName: "Ratios & Multiples",
		type: "num",
		subFields: [
			{
				name: "0_Q",
				title: "Current quarter",
				titleShort: "Q",
			},
		],
	},
];
